import React from 'react';
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';

const TermsOfService = () => {
  return (
    <div>
      <Navigation />

      <section className="section-padding bg-white" data-testid="terms-of-service">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl sm:text-5xl font-bold mb-8" style={{ color: 'var(--text-dark)' }}>
              Terms of Service
            </h1>
            
            <div className="space-y-8 text-gray-700 leading-relaxed">
              <div>
                <h2 className="text-2xl font-bold mb-4" style={{ color: 'var(--text-dark)' }}>
                  Agreement to Terms
                </h2>
                <p>
                  By accessing and using the services provided by Orbit Marks, you agree to be bound by these Terms of Service. If you do not agree with any part of these terms, please do not use our services.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4" style={{ color: 'var(--text-dark)' }}>
                  Services Provided
                </h2>
                <p className="mb-3">
                  We provide trademark registration, copyright registration, company formation, and related intellectual property services. Our services include:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Trademark search and analysis</li>
                  <li>Trademark application preparation and filing</li>
                  <li>Copyright registration assistance</li>
                  <li>Company formation and structuring</li>
                  <li>Brand protection and monitoring</li>
                  <li>Amazon Brand Registry assistance</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4" style={{ color: 'var(--text-dark)' }}>
                  User Responsibilities
                </h2>
                <p className="mb-3">
                  When using our services, you agree to:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Provide accurate and complete information</li>
                  <li>Maintain the confidentiality of your account</li>
                  <li>Notify us immediately of any unauthorized use</li>
                  <li>Use our services only for lawful purposes</li>
                  <li>Not infringe on the intellectual property rights of others</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4" style={{ color: 'var(--text-dark)' }}>
                  Fees and Payment
                </h2>
                <p>
                  Our service fees are clearly displayed on our website. Government filing fees are separate and are paid directly to the relevant government agencies. All fees are non-refundable unless otherwise specified. We reserve the right to change our fees with notice.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4" style={{ color: 'var(--text-dark)' }}>
                  No Guarantee of Approval
                </h2>
                <p>
                  While we make every effort to ensure successful trademark registration, we cannot guarantee that your trademark application will be approved by the USPTO or other trademark offices. Approval depends on various factors including trademark availability and compliance with legal requirements.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4" style={{ color: 'var(--text-dark)' }}>
                  Limitation of Liability
                </h2>
                <p>
                  To the maximum extent permitted by law, Orbit Marks shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or relating to your use of our services. Our total liability shall not exceed the amount you paid for our services.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4" style={{ color: 'var(--text-dark)' }}>
                  Intellectual Property
                </h2>
                <p>
                  All content on our website, including text, graphics, logos, and software, is the property of Orbit Marks and is protected by copyright and trademark laws. You may not reproduce, distribute, or create derivative works without our written permission.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4" style={{ color: 'var(--text-dark)' }}>
                  Confidentiality
                </h2>
                <p>
                  We maintain the confidentiality of all information you provide to us in connection with our services. We will not disclose your information to third parties except as required by law or with your consent.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4" style={{ color: 'var(--text-dark)' }}>
                  Termination
                </h2>
                <p>
                  We reserve the right to terminate or suspend your access to our services at any time, without prior notice, for conduct that we believe violates these Terms of Service or is harmful to other users, us, or third parties.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4" style={{ color: 'var(--text-dark)' }}>
                  Governing Law
                </h2>
                <p>
                  These Terms of Service shall be governed by and construed in accordance with the laws of the United States, without regard to its conflict of law provisions.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4" style={{ color: 'var(--text-dark)' }}>
                  Changes to Terms
                </h2>
                <p>
                  We reserve the right to modify these Terms of Service at any time. We will notify users of any material changes by posting the updated terms on our website. Your continued use of our services after such changes constitutes acceptance of the new terms.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4" style={{ color: 'var(--text-dark)' }}>
                  Contact Information
                </h2>
                <p>
                  If you have any questions about these Terms of Service, please contact us at:
                </p>
                <p className="mt-3 font-semibold">
                  Email: legal@mytmbrand.com<br />
                  Phone: 1-800-TM-BRAND
                </p>
              </div>

              <div className="pt-8 border-t border-gray-200">
                <p className="text-sm text-gray-500">
                  Last Updated: January 2026
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TermsOfService;